/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ScenariosRouteImport } from './routes/scenarios'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as AssetsRouteImport } from './routes/assets'
import { Route as AdjustmentsRouteImport } from './routes/adjustments'
import { Route as IndexRouteImport } from './routes/index'

const ScenariosRoute = ScenariosRouteImport.update({
  id: '/scenarios',
  path: '/scenarios',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultsRoute = ResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsRoute = AssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => rootRouteImport,
} as any)
const AdjustmentsRoute = AdjustmentsRouteImport.update({
  id: '/adjustments',
  path: '/adjustments',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/adjustments': typeof AdjustmentsRoute
  '/assets': typeof AssetsRoute
  '/results': typeof ResultsRoute
  '/scenarios': typeof ScenariosRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/adjustments': typeof AdjustmentsRoute
  '/assets': typeof AssetsRoute
  '/results': typeof ResultsRoute
  '/scenarios': typeof ScenariosRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/adjustments': typeof AdjustmentsRoute
  '/assets': typeof AssetsRoute
  '/results': typeof ResultsRoute
  '/scenarios': typeof ScenariosRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/adjustments' | '/assets' | '/results' | '/scenarios'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/adjustments' | '/assets' | '/results' | '/scenarios'
  id: '__root__' | '/' | '/adjustments' | '/assets' | '/results' | '/scenarios'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdjustmentsRoute: typeof AdjustmentsRoute
  AssetsRoute: typeof AssetsRoute
  ResultsRoute: typeof ResultsRoute
  ScenariosRoute: typeof ScenariosRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/scenarios': {
      id: '/scenarios'
      path: '/scenarios'
      fullPath: '/scenarios'
      preLoaderRoute: typeof ScenariosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/results': {
      id: '/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof ResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets': {
      id: '/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AssetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/adjustments': {
      id: '/adjustments'
      path: '/adjustments'
      fullPath: '/adjustments'
      preLoaderRoute: typeof AdjustmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdjustmentsRoute: AdjustmentsRoute,
  AssetsRoute: AssetsRoute,
  ResultsRoute: ResultsRoute,
  ScenariosRoute: ScenariosRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
